import { render, staticRenderFns } from "./ThemeVT.vue?vue&type=template&id=6d9d8a3c"
import script from "./ThemeVT.vue?vue&type=script&lang=js"
export * from "./ThemeVT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports